import React from 'react';
import { Dialog, DialogContent } from '@mui/material';

export const ModalTemplate = ({
    open,
    onClose,
    maxWidth = 'sm',
    children
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
            <DialogContent dividers>{children}</DialogContent>
        </Dialog>
    );
};

